import React from 'react';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core';

import CircularProgress from '@material-ui/core/CircularProgress';
import './circular_progress_button.scss';

export const theme = createTheme((theme) => ({
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
}));

export const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    height: 10,
  },
};

const CircularIndeterminate = (props) => {
  const { classes } = props;

  return (
    <MuiThemeProvider theme={theme}>
      {void window.scrollTo(0, 0)}
      <div className={`${classes.root} flex-column circular_Progress_button_main`}>
        <CircularProgress />
      </div>
    </MuiThemeProvider>
  );
};

export default withStyles(styles)(CircularIndeterminate);